<template>
  <div>
    <h3 class="h3 mt0">My Information</h3>
    <p class="p">Please let us know about your detailed information:</p>

    <transition
      name="fade"
      mode="out-in"
    >
      <module-form
        v-if="editDetails"

        key="info-form"

        form-id="dashboard-info"
        :fields="fields"

        button-size="m"
        button="primary"

        submit="Save Changes"
        :action="action"
        :success="success"
        :fail="fail"
      >
        <module-button
          slot="submit-extras"
          button="tertiary"
          size="m"
          type="button"
          @click.native="toggleEdit()"
          label="Cancel"
        />
      </module-form>

      <div
        v-if="!editDetails"

        key="info-details"
      >
        <module-detail-list
          v-if="aboutItems"

          title="About"
          :items="aboutItems"
        />
        <module-detail-list
          v-if="addressItems"

          title="Address Information"
          :items="addressItems"
        />
        <module-button
          size="m"
          @click.native="toggleEdit()"
          level="secondary"
          button="secondary"
          label="Edit my details"
        />
      </div>
    </transition>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { arrayLoop, arrayIncludes } from 'services/array';
import { americanizePhoneNumber } from 'services/string';

// Models
import { patientDetails, dentistDetails, address } from 'models/dashboard/userDetails';

// Modules
import ModuleForm from 'modules/Form';
import ModuleButton from 'modules/Button';
import ModuleDetailList from 'modules/DetailList';

// Export
export default {
  name: `ui-dashboard-my-information`,

  // Components
  components: {
    ModuleForm,
    ModuleButton,
    ModuleDetailList,
  },

  data () {
    return {
      editDetails: false,
      patientForm: {
        ...patientDetails,
        ...address,
      },
      doctorForm: {
        ...dentistDetails,
      },
      profileFields: [
        `license_number`,
        `phone_number`,
        `specialty`,
      ],
      // requiredData: [
      //   `first_name`,
      //   `last_name`,
      // ],
    };
  },
  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
      `getStatus`,
    ]),
    ...mapGetters(`auth`, [
      `user`,
      `userRole`,
      `userIsRole`,
      `showTour`,
    ]),
    ...mapGetters(`review`, [
      `reviewNomenclatureBySlug`,
      `reviewNomenclatureBySlugAndId`,
    ]),
    model() {
      return this.getModel(`dashboard-info`);
    },
    dataComplete() {
      let finished = true;

      let requiredData = [
        `first_name`,
        `last_name`,
      ];

      if (this.userIsRole([2, 3])) {
        requiredData = [
          ...requiredData,
          `license_number`,
          `phone_number`,
          `specialty`,
        ];
      }

      arrayLoop(requiredData, (i, key) => {
        let field = this.user[key];

        if (arrayIncludes(this.profileFields, key)) field = this.user.profile[key];

        if (!field) finished = false;
      });

      return finished;
    },
    fields() {
      if (this.userIsRole([1])) {
        return this.patientForm;
      }

      const fields = this.doctorForm;

      fields.specialty.items = this.reviewNomenclatureBySlug(`specialties`);

      return fields;
    },
    aboutItems() {
      const user = this.user || {};

      let items = {
        'First Name': user.first_name,
        'Last Name': user.last_name,
        'Email Address': user.email,
      };

      if (this.userIsRole([2, 3])) {
        const profile = user.profile || {};

        items = {
          ...items,
          'License Number': profile.license_number || null,
          'Main Phone Number': profile.phone_number || null,
          'Speciality': this.reviewNomenclatureBySlugAndId(`specialties`, profile.specialty) || null,
        };
      }

      return items;
    },
    addressItems() {
      const user = this.user;

      if (!this.userIsRole([1])) return null;

      return {
        'Address Line One': user.address_line_1,
        'Address Line Two': user.address_line_2,
        'City': user.city,
        'ZIP': user.zip,
      };
    },
  },

  // Methods
  methods: {
    ...mapActions(`forms`, [
      `updateValue`,
    ]),
    ...mapActions(`auth`, [
      `requestUpdateUser`,
    ]),
    toggleEdit() {
      if (this.editDetails) {
        this.editDetails = false;
      } else {

        arrayLoop(this.fields, key => {
          let field = this.user[key];

          if (arrayIncludes(this.profileFields, key)) field = this.user.profile[key];

          this.fields[key].value = field || null;
        });

        this.$nextTick(() => this.editDetails = true);
      }
    },
    action() {
      const model = this.model;

      if (this.userIsRole([2, 3])) {
        model.profile = {};

        arrayLoop(this.profileFields, (i, key) => {
          key === `phone_number` ? model.profile[key] = americanizePhoneNumber(model[key]) :   model.profile[key] = model[key];
        });
      }
      
      return this.requestUpdateUser(this.model);
    },
    success() {
      if(this.showTour) {
        this.$router.push({
          name: `dashboard-dentist-locations`,
        });
      } else {
        setTimeout(() => {
          this.toggleEdit();
        }, 1000);
      }
    },
    fail(fail) {
      console.warn(fail);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MyInfo.vue?9ec08f02